import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PermissionService } from "src/app/permission.service";

@Injectable({
  providedIn: "root",
})
export class AccountSignalCategoryListGuard implements CanActivate {
  constructor(
    private permissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | Observable<boolean> {
    return from(
      this.permissionService.categories.accountSignalCategories.hasList(),
    ).pipe(
      map((res) => {
        if (!res) {
          this.router.navigate([""]);
        }
        return res;
      }),
    );
  }
}
